import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDistanceToNow } from 'date-fns';
import { enUS, ja } from 'date-fns/locale';

const LOCALES = { ja, en: enUS } as const;

/** date-fns defaults to English, which left "2 days ago" inside Japanese copy. */
export function useRelativeTime() {
  const { i18n } = useTranslation();
  const locale = LOCALES[i18n?.language?.slice(0, 2) as keyof typeof LOCALES] ?? enUS;

  return useCallback(
    (value: string | Date | undefined | null): string => {
      if (!value) return '';
      const date = value instanceof Date ? value : new Date(value);
      return Number.isNaN(date.getTime())
        ? ''
        : formatDistanceToNow(date, { addSuffix: true, locale });
    },
    [locale],
  );
}
